import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询借阅类型列表
export function queryBorrowType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrowType/queryBorrowType',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加借阅类型
export function saveBorrowType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrowType/saveBorrowType',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新借阅类型
export function updateBorrowType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrowType/updateBorrowType',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除借阅类型
export function deleteBorrowType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/borrowType/deleteBorrowType',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}